import React from 'react';
import { Eye, Pencil, Trash2, Loader2 } from 'lucide-react';

const statusBadge = {
  pending: 'bg-amber-50 text-amber border-amber-200',
  published: 'bg-primary-50 text-primary border-primary-200',
  rejected: 'bg-red-50 text-red-600 border-red-200',
};

const content = {
  ne: {
    title: 'शीर्षक',
    sector: 'क्षेत्र',
    reporter: 'रिपोर्टर',
    date: 'मिति',
    actions: 'कार्य',
  },
  en: {
    title: 'Title',
    sector: 'Sector',
    reporter: 'Reporter',
    date: 'Date',
    actions: 'Actions',
  },
};

const PendingArticleTable = ({ articles, language, actionLoadingId, onReview, onEdit, onDelete }) => {
  const t = content[language] || content.en;

  return (
    <div className="overflow-hidden rounded-3xl border border-char-100 bg-white">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-char-100 bg-char-50/50 text-left text-xs font-extrabold uppercase tracking-wider text-char-400">
              <th className="px-5 py-3">{t.title}</th>
              <th className="px-5 py-3">{t.sector}</th>
              <th className="px-5 py-3">{t.reporter}</th>
              <th className="px-5 py-3">{t.date}</th>
              <th className="px-5 py-3 text-right">{t.actions}</th>
            </tr>
          </thead>
          <tbody>
            {articles.map((article) => {
              const id = article._id ?? article.id;
              const isLoading = actionLoadingId === id;
              const badge = statusBadge[article.status] || statusBadge.pending;

              return (
                <tr key={id} className="border-b border-char-50 last:border-0 hover:bg-char-50/40">
                  <td className="max-w-xs truncate px-5 py-3 font-bold text-char-900">
                    {article.title}
                  </td>
                  <td className="px-5 py-3">
                    <span className={`inline-flex rounded-full border px-2.5 py-1 text-xs font-bold ${badge}`}>
                      {article.sector}
                    </span>
                  </td>
                  <td className="px-5 py-3 text-char-500">
                    {article.author?.name || '—'}
                  </td>
                  <td className="px-5 py-3 text-char-400">
                    {article.createdAt ? new Date(article.createdAt).toLocaleDateString() : '—'}
                  </td>
                  <td className="px-5 py-3">
                    <div className="flex items-center justify-end gap-2">
                      {isLoading ? (
                        <Loader2 size={16} className="animate-spin text-primary" />
                      ) : (
                        <>
                          <button
                            onClick={() => onReview(article)}
                            title={language === 'ne' ? 'समीक्षा गर्नुहोस्' : 'Review'}
                            className="rounded-xl p-2 text-char-400 transition-colors hover:bg-primary-50 hover:text-primary"
                          >
                            <Eye size={16} />
                          </button>
                          <button
                            onClick={() => onEdit(article)}
                            title={language === 'ne' ? 'सम्पादन गर्नुहोस्' : 'Edit'}
                            className="rounded-xl p-2 text-char-400 transition-colors hover:bg-blue-50 hover:text-blue-600"
                          >
                            <Pencil size={16} />
                          </button>
                          <button
                            onClick={() => onDelete(article)}
                            title={language === 'ne' ? 'मेटाउनुहोस्' : 'Delete'}
                            className="rounded-xl p-2 text-char-400 transition-colors hover:bg-red-50 hover:text-red-600"
                          >
                            <Trash2 size={16} />
                          </button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PendingArticleTable;